import { PLATFORMS } from '../../constants';

const Platform = Object.freeze({ OS: PLATFORMS.web });

export default Platform;